<template>
  <v-toolbar app color="primary" dense>
    <v-btn icon :to="{name: 'home'}">
      <img src="/img/icons/heap-32x32.png" style="width:100%"/>
    </v-btn>
    <v-toolbar-items>
      <v-btn :to="{name: 'regions'}" flat dark>Regions</v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn :to="{name: 'satellite'}" flat dark>BPI</v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn :to="{name: 'adsellers'}" flat dark>Ad Sellers</v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn flat @click="authenticate" dark>
        {{authText}}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
export default {
  name: "NavBar",
  data () {
    return {}
  },
  methods: {
    authenticate () {
      if(this.loggedIn) {
        this.$store.dispatch('logOut')
        this.$api.removeRequestHeader('auth-token')
      } else {
        this.$gAuth.signIn()
        .then(GoogleUser => {
          var axiosConfig = {
            url: '/login/',
            method: "post",
            data: {
              role: 'Administrator',
              email: GoogleUser.getBasicProfile().getEmail()
            },
            headers: {
              "google-oauth-token": GoogleUser.getAuthResponse().access_token,
            }
          }
          this.axios(axiosConfig).then((response) => {
            this.$store.dispatch('logIn', response.data)
            this.$api.setRequestHeader('auth-token', response.data.token)
          }).catch((error) => {
            // error in posting
            console.log('Login error', error)
          })
        })
        .catch(error  => {
          //on fail do something
          console.log('OAuth failure', error)
        })
      }
    }
  },
  computed: {
    authText() {
      return this.loggedIn ? "Log out" : "Log in"
    },
    loggedIn () {
      return this.$store.getters.getAuthToken != null
    }
  },
  mounted () {
  }
}
</script>
<style lang="stylus">
</style>
